
import { __callbacks } from "Utils/Callbacks/Callback";
import styles from "./UserNotification.module.scss";

export default function UserNotification(props: any) {

  const onButtonCloseClick = () => {
    __callbacks.userNotificationClose.trigger({});
  }

  return (
    <div className={`${styles.container}`}>
      <div className={`${styles["container-wrapper"]}`}>
        <div className={`${styles["container-body"]}`}>
          <div className={styles["header"]}>
            <div className={styles["icon"]}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="17" viewBox="0 0 18 17" fill="none">
                <path d="M10.1347 12.6634C10.1347 13.3242 9.69166 13.8175 9.00705 13.8175H8.98326C8.32245 13.8175 7.86661 13.3242 7.86661 12.6634C7.86661 11.9797 8.33613 11.5102 9.00705 11.5102C9.67798 11.5102 10.1228 11.9779 10.1347 12.6634ZM8.28488 10.8769H9.73194L10.0084 5.13454H8.00572L8.28488 10.8769ZM17.8337 15.7231C17.6242 16.0664 17.2516 16.2778 16.8508 16.2778H1.1505C0.735876 16.2778 0.353292 16.0545 0.148323 15.6939C-0.0539294 15.3333 -0.0493391 14.8931 0.162094 14.5371L8.04151 0.558326C8.24835 0.209653 8.62269 0 9.02719 0H9.0583C9.4747 0.0100236 9.84904 0.245251 10.0431 0.613222L17.8667 14.5928C18.0534 14.9488 18.0452 15.3763 17.8337 15.7231ZM16.8508 15.1236L9.02626 1.1486L1.15144 15.1236H16.8508Z" fill="#e91e63" />
              </svg>
            </div>
            <h3 className={styles["title"]}>Alert</h3>
            <div onClick={onButtonCloseClick} className={styles["icon-close"]}>
              <img src="./assets/icons/close-black.svg" alt="" srcSet="" />
            </div>
          </div>
          {props.children}
        </div>
      </div>
    </div>
  )
}
